import { ValidatorRuleType } from "@gaiaProfessionals/Common/Utilities/validate";
import translate from "@insite/client-framework/Translate";

export const intialErrorFormStateLegacy = {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    practiceName: "",
    practiceType: "",
    partitionerCertificate: "",
    country: "",
    state: "",
    city: "",
    postalCode: "",
    address1: "",
    howDidYouLearn: "",
    currentlySellProducts: "",
    schoolAttended: "",
    conferences: "",
    hasWebsite: "",
    clientWebsiteUrl: "",
    sellProductsOnWebsite: "",
    howYouProvideToPatients: "",
};

export const intialErrorFormState = {
    firstName: undefined,
    lastName: undefined,
    email: undefined,
    phoneNumber: undefined,
    practiceName: undefined,
    practiceType: undefined,
    partitionerCertificate: undefined,
    country: undefined,
    state: undefined,
    city: undefined,
    postalCode: undefined,
    address1: undefined,
    howDidYouLearn: undefined,
    currentlySellProducts: undefined,
    schoolAttended: undefined,
    conferences: undefined,
    hasWebsite: undefined,
    clientWebsiteUrl: undefined,
    sellProductsOnWebsite: undefined,
    howYouProvideToPatients: undefined,
};

export const practiceTypeOptions = [
    {
        value: "DC",
        label: "DC",
    },
    {
        value: "DDS",
        label: "DDS",
    },
    {
        value: "DO",
        label: "DO",
    },
    {
        value: "DTR",
        label: "DTR",
    },
    {
        value: "Health/Wellness Coach",
        label: "Health/Wellness Coach",
    },
    {
        value: "Herbalist",
        label: "Herbalist",
    },
    {
        value: "Lac",
        label: "Lac",
    },
    {
        value: "LMT",
        label: "LMT",
    },
    {
        value: "MD",
        label: "MD",
    },
    {
        value: "Midwife",
        label: "Midwife",
    },
    {
        value: "ND",
        label: "ND",
    },
    {
        value: "NP",
        label: "NP",
    },
    {
        value: "Nutritionist",
        label: "Nutritionist",
    },
    {
        value: "OMD",
        label: "OMD",
    },
    {
        value: "PA",
        label: "PA",
    },
    {
        value: "RD",
        label: "RD",
    },
    {
        value: "RN",
        label: "RN",
    },
    {
        value: "RPH",
        label: "RPH",
    },
    {
        value: "Student",
        label: "Student",
    },
];

export const interestedInGaiaHerbs = [
    {
        value: "personal use only",
        label: "Personal use only",
    },
    {
        value: "patients/clients only",
        label: "Patients/Clients only",
    },
    {
        value: "both personal and patients/clients",
        label: "Both",
    },
];

export const recommendationsOptions = [
    {
        value: "Dont recommend herbs to patients/clients",
        label: "Don't recommend herbs to patients/clients",
    },
    {
        value: "We sell in our office",
        label: "We sell in our office",
    },
    {
        value: "We refer patients/clients to a retail store",
        label: "We refer patients/clients to a retail store",
    },
    {
        value: "We refer patients/clients to an online shop",
        label: "We refer patients/clients to an online shop",
    },
    {
        value: "We use a patient drop ship or online patient dispensary program",
        label: "We use a patient drop ship or online patient dispensary program",
    },
    {
        value: "Combination- sell in office and use online patient dispensary program",
        label: "Combination- sell in office and use online patient dispensary program",
    },
];

export const refererOptions = [
    {
        value: "gaiaherbs.com",
        label: "gaiaherbs.com",
    },
    {
        value: "Social media",
        label: "Social media",
    },
    {
        value: "Webinar",
        label: "Webinar",
    },
    {
        value: "Trade Show",
        label: "Trade Show",
    },
    {
        value: "Google/Web search",
        label: "Google/Web search",
    },
    {
        value: "Other",
        label: "Other",
    },
];

export interface ValidatorConfigType {
    [key: string]: ValidatorRuleType;
}

export interface FormErrorsStateType {
    [key: string]: string | undefined;
}

export const newCustomerValidatorConfig: ValidatorConfigType = {
    firstName: {
        label: translate("First Name"),
        placeholder: translate("Enter first name"),
        required: true,
        minLength: 2,
    },
    lastName: {
        label: translate("Last Name"),
        placeholder: translate("Enter last name"),
        required: true,
        minLength: 2,
    },
    email: {
        label: translate("Email Address"),
        placeholder: translate("Enter your email address"),
        required: true,
        regex: /\w+([-+."]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/,
        regexMsg: translate("Please Enter Email in username@email.com Format"),
    },
    phoneNumber: {
        label: translate("Phone Number"),
        placeholder: translate("Enter Phone Number"),
        required: true,
        maxLength: 12,
        maxLengthMsg: translate("Please Enter Valid Phone Number"),
    },
    extension: {
        label: translate("Country Extension Code"),
        placeholder: translate("Enter country extension code"),
    },
    practiceSpeciality: {
        label: translate("Practitioner Speciality"),
        required: true,
    },
    practiceName: {
        label: translate("Practice Name"),
        placeholder: translate("Enter practice name"),
        required: true,
    },
    practitionerCertificate: {
        label: translate("Upload Practitioner Credentials"),
        placeholder: translate("FileUpload Placeholder"),
        required: true,
    },
    taxResellCertificate: {
        label: translate("Upload Tax Resale Certificate"),
        placeholder: translate("FileUpload Placeholder"),
    },
    taxIdEin: {
        label: translate("Tax ID/EIN"),
        placeholder: translate("Enter Tax ID/EIN"),
    },
    country: {
        label: translate("Country"),
        required: true,
    },
    address1: {
        label: translate("Address Line 1"),
        placeholder: translate("Enter Address 1"),
        required: true,
    },
    address2: {
        label: translate("Address Line 2"),
        placeholder: translate("Enter Address 2"),
    },
    state: {
        label: translate("State/Province"),
        placeholder: translate("Enter state/Province"),
        required: true,
    },
    city: {
        label: translate("City"),
        placeholder: translate("Enter city"),
        required: true,
    },
    postalCode: {
        label: translate("Postal Code"),
        placeholder: translate("Enter Postal Code"),
        required: true,
        regex: /^[a-zA-Z0-9 ]*$/,
    },
    shipCountry: {
        label: translate("Country"),
        required: true,
    },
    shipAddress1: {
        label: translate("Address Line 1"),
        placeholder: translate("Enter Address 1"),
        required: true,
    },
    shipAddress2: {
        label: translate("Address Line 2"),
        placeholder: translate("Enter Address 2"),
    },
    shipState: {
        label: translate("State/Province"),
        placeholder: translate("Enter state/Province"),
        required: true,
    },
    shipCity: {
        label: translate("City"),
        placeholder: translate("Enter city"),
        required: true,
    },
    shipPostalCode: {
        label: "",
        placeholder: "",
        regex: /^[a-zA-Z0-9 ]*$/,
    },
    shipPhoneNumber: {
        label: translate("Phone Number"),
        placeholder: translate("Enter Phone Number"),
        required: true,
        maxLength: 12,
        maxLengthMsg: translate("Please Enter Valid Phone Number"),
    },
    howDidYouLearn: {
        label: translate("How did you learn about us?"),
        placeholder: translate("i.e. social media, search results, etc."),
        required: true,
    },
    currentlySellProducts: {
        label: translate("Do you currently sell Gaia Herbs products?"),
        required: true,
    },
    schoolAttended: {
        label: translate("School Attended?"),
        placeholder: translate("Enter school name attended"),
    },
    conferences: {
        label: translate("If you attend conferences, please list them here."),
        placeholder: translate("List conferences..."),
    },
    hasWebsite: {
        label: translate("Do you have a website?"),
        required: true,
    },
    clientWebsiteUrl: {
        label: translate("Website URL"),
        placeholder: translate("Enter Website URL (website.com)"),
        required: true,
        regex: /^((http(s?)?):\/\/)?([wW]{3}\.)?[a-zA-Z0-9\-.]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})*/,
        regexMsg: translate("Please Enter Website URL in 'website.com' Format"),
    },
    sellProductsOnWebsite: {
        label: translate("If so, do you resell supplements on your website?"),
        required: true,
    },
    howYouProvideToPatients: {
        label: translate("How do you get herbs and supplements to patients?"),
        required: true,
        options: [
            {
                optLabel: "This account is for personal/educational use only",
                value: "personal_or_educational",
            },
            {
                optLabel: "Sell in office",
                value: "sell_office",
            },
            {
                optLabel: "Refer to a retail shop",
                value: "retail_shop",
            },
            {
                optLabel: "Refer to an online shop",
                value: "online_shop",
            },
            {
                optLabel: "Use a patient drop ship or online patient dispensary program",
                value: "patient_drop_ship_or_online_dispensary",
            },
        ]
    }
};